import {
  IBieOnboardingValidationIssue,
  IBieValidationRemediation,
} from './bieonboardingworkbench.models';

export interface IBieRenderedRemediation extends IBieValidationRemediation {
  order: number;
}

const normalized = (value?: string | null): string =>
  String(value || '').trim().toUpperCase();

const supplied = (
  issue: IBieOnboardingValidationIssue,
): IBieRenderedRemediation[] => {
  
  const rows = issue.vdd?.remediation;
  if (!Array.isArray(rows)) return [];

  return rows
    .filter((item) => Boolean(item?.code))
    .map((item, index) => ({
      code: String(item.code || ''),
      name: String(item.name || item.code || 'Action'),
      description: item.description == null ? undefined : String(item.description),
      recommended: Boolean(item.recommended),
      automatic: Boolean(item.automatic),
      enabled: item.enabled === undefined ? true : Boolean(item.enabled),
      params:
        item.params && typeof item.params === 'object'
          ? item.params as Record<string, unknown>
          : undefined,
      order: Number(item.order || index + 1),
    }))
    //.filter((item) => Boolean(item.code))
    .sort((a, b) => a.order - b.order);
};

const fallback = (
  issue: IBieOnboardingValidationIssue,
): IBieRenderedRemediation[] => {
  switch (normalized(issue.rlc)) {
    case 'EXISTING_CANONICAL_FACT':
      return [
        { code: 'COMPARE_RESOLVE', name: 'Compare and Resolve', order: 1, recommended: true },
      ];

    case 'UNIT_MISMATCH':
      return [
        {
          code: 'OPEN_UNIT_ALIAS',
          name: 'Configure Unit Alias',
          order: 1,
          recommended: true,
          params: {
            aliasCode: issue.vdd?.suppliedUnitCode,
            canonicalUnitId: issue.vdd?.canonicalUnitId,
            canonicalUnitCode: issue.vdd?.canonicalUnitCode,
          },
        },
        { code: 'OPEN_DRIVER', name: 'Review Driver Unit', order: 2 },
        { code: 'OPEN_IMPORT_ITEM', name: 'Correct Source Record', order: 3 },
      ];

    case 'VALUE_ABOVE_MAXIMUM':
      return [
        { code: 'OPEN_DRIVER_THRESHOLD', name: 'Review Driver Threshold', order: 1, recommended: true },
        { code: 'OPEN_IMPORT_ITEM', name: 'Correct Source Record', order: 2 },
        { code: 'REQUEST_DECISION', name: 'Request Governance Decision', order: 3 },
      ];

    case 'PRODUCT_UNKNOWN':
      return [
        { code: 'OPEN_PRODUCT_ALIAS', name: 'Configure Product Alias', order: 1, recommended: true },
        { code: 'OPEN_PRODUCT', name: 'Review Product', order: 2 },
        { code: 'OPEN_IMPORT_ITEM', name: 'Correct Source Record', order: 3 },
      ];

    case 'LOCATION_UNKNOWN':
      return [
        { code: 'OPEN_LOCATION_ALIAS', name: 'Configure Location Alias', order: 1, recommended: true },
        { code: 'OPEN_LOCATION', name: 'Review Location', order: 2 },
        { code: 'OPEN_IMPORT_ITEM', name: 'Correct Source Record', order: 3 },
      ];

    default:
      return [
        { code: 'OPEN_IMPORT_ITEM', name: 'Review Source Record', order: 1 },
      ];
  }
};

export const getBieIssueRemediation = (
  issue: IBieOnboardingValidationIssue,
): IBieRenderedRemediation[] => {
  const defined = supplied(issue);
  return defined.length ? defined : fallback(issue);
};
